module.exports = __webpack_public_path__ + "public/images/slider/filimonova.a80a138a829f708165b3f24e05fdddf8.webp";